module.exports = __webpack_public_path__ + "static/img/prize_bg.d7a2774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/prize_bg.png
// module id = 277
// module chunks = 6